export enum PaymentProcessingStatus {
  pending = 'pending',
  paid = 'paid',
  incoming = 'incoming',
  cancelled = 'cancelled',
  expired = 'expired',
  failed = 'failed'
}
